(function () {
  if (window.klaviyoInStoreForm && window.klaviyoInStoreForm.__amBound) return;

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function getModal() {
    return document.querySelector('[data-am-klaviyo-in-store-modal]');
  }

  function getActiveModal() {
    var modal = getModal();
    if (!modal || modal.hidden) return null;
    return modal;
  }

  function parseVariants(modal) {
    var script = modal.querySelector('[data-am-klaviyo-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function sizeForVariantId(modal, variantId, sizeField) {
    var sizeOptionIndex = parseInt(modal.dataset.sizeOptionIndex, 10);
    var variants = parseVariants(modal);
    var match = variants.filter(function (v) {
      return String(v.id) === String(variantId);
    })[0];
    if (!match) return sizeField ? sizeField.value : '';
    if (
      sizeOptionIndex >= 0 &&
      match.options &&
      match.options[sizeOptionIndex] !== undefined
    ) {
      return match.options[sizeOptionIndex];
    }
    return match.title || '';
  }

  function updateIntroSize(modal, size) {
    var sizeEl = modal.querySelector('[data-am-klaviyo-intro-size]');
    var wrap = modal.querySelector('[data-am-klaviyo-intro-size-wrap]');
    if (sizeEl) sizeEl.textContent = size || '';
    if (wrap) wrap.hidden = !size;
  }

  function setVariant(variantId) {
    var modal = getModal();
    if (!modal || !variantId) return;
    var form = modal.querySelector('.klaviyo-in-store-form__form');
    if (!form) return;
    var sizeField = form.querySelector('input[name="size"]');
    var variantIdField = form.querySelector('input[name="variant_id"]');
    var size = sizeForVariantId(modal, variantId, sizeField);
    if (sizeField) sizeField.value = size;
    if (variantIdField) variantIdField.value = variantId;
    updateIntroSize(modal, size);
  }

  function syncFromProductForm() {
    var idInput = document.querySelector(
      'product-form form [name="id"], form[data-type="add-to-cart-form"] [name="id"]',
    );
    if (idInput && idInput.value) setVariant(idInput.value);
  }

  function open() {
    var modal = getModal();
    if (!modal) return;
    syncFromProductForm();
    /*
     * Product sections can create their own stacking contexts. Move the modal
     * directly under <body> so its fixed backdrop covers the header, drawers,
     * sticky bars, and every other page section.
     */
    document.body.appendChild(modal);
    modal.hidden = false;
    document.body.classList.add('am-klaviyo-in-store-modal-open');
    var dialog = modal.querySelector('.am-klaviyo-in-store-modal__dialog');
    var email = modal.querySelector('input[name="email"]');
    requestAnimationFrame(function () {
      (email || dialog)?.focus?.();
    });
  }

  function close() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('am-klaviyo-in-store-modal-open');
  }

  function bindModal(modal) {
    if (modal.dataset.amKlaviyoBound === '1') return;
    modal.dataset.amKlaviyoBound = '1';

    var companyId = modal.dataset.klaviyoCompanyId;
    var listId = modal.dataset.klaviyoListId;
    var metricName = modal.dataset.klaviyoMetric || 'In-Store Product Interest';
    var productTitle = modal.dataset.productTitle;
    var productId = modal.dataset.productId;
    var productUrl = modal.dataset.productUrl;
    var productImage = modal.dataset.productImage;

    var form = modal.querySelector('.klaviyo-in-store-form__form');
    if (!form) return;

    var sizeField = form.querySelector('input[name="size"]');
    var statusEl = form.querySelector('.klaviyo-in-store-form__status');
    var submitBtn = form.querySelector('.klaviyo-in-store-form__submit');

    modal.querySelectorAll('[data-am-klaviyo-in-store-close]').forEach(function (el) {
      el.addEventListener('click', function (evt) {
        evt.preventDefault();
        close();
      });
    });

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();

      var email = (form.querySelector('input[name="email"]')?.value || '').trim();
      var name = (form.querySelector('input[name="name"]')?.value || '').trim();
      var phone = (form.querySelector('input[name="phone"]')?.value || '').trim();
      var size = sizeField ? sizeField.value : '';

      if (!email) {
        statusEl.textContent = 'Please enter your email.';
        statusEl.dataset.state = 'error';
        return;
      }

      submitBtn.disabled = true;
      statusEl.textContent = 'Sending...';
      statusEl.dataset.state = '';

      var profileAttributes = { email: email };
      if (name) profileAttributes.first_name = name;
      if (phone) profileAttributes.phone_number = phone;

      var eventPayload = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              'Product Name': productTitle,
              Size: size,
              'Product ID': productId,
              'Product URL': productUrl,
              'Product Image': productImage,
            },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: metricName },
              },
            },
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes,
              },
            },
          },
        },
      };

      var requests = [
        fetch('https://a.klaviyo.com/client/events/?company_id=' + companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15',
          },
          body: JSON.stringify(eventPayload),
        }),
      ];

      if (listId) {
        var subscriptionPayload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: Object.assign({}, profileAttributes, {
                    properties: {
                      'Product Interested In': productTitle,
                      'Size Interested In': size,
                    },
                  }),
                },
              },
              custom_source: 'In-Store Interest Form',
            },
            relationships: {
              list: {
                data: { type: 'list', id: listId },
              },
            },
          },
        };

        requests.push(
          fetch(
            'https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                revision: '2024-10-15',
              },
              body: JSON.stringify(subscriptionPayload),
            },
          ),
        );
      }

      Promise.all(requests)
        .then(function (responses) {
          var ok = responses.every(function (r) {
            return r.ok || r.status === 202;
          });
          if (ok) {
            statusEl.textContent = "Thanks! We'll be in touch about this item.";
            statusEl.dataset.state = 'success';
            form.reset();
            if (sizeField) sizeField.value = size;
            updateIntroSize(modal, size);
            submitBtn.style.display = 'none';
          } else {
            throw new Error('Klaviyo request failed');
          }
        })
        .catch(function () {
          statusEl.textContent = 'Something went wrong — please try again.';
          statusEl.dataset.state = 'error';
          submitBtn.disabled = false;
        });
    });
  }

  function init() {
    var modal = getModal();
    if (modal) bindModal(modal);
  }

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.name === 'id' && evt.target.value) {
      setVariant(evt.target.value);
    }
  });

  document.addEventListener('click', function (evt) {
    var proxy = evt.target.closest?.('a.am-klaviyo-in-store-proxy, a.am-klaviyo-in-store-trigger');
    if (!proxy) return;
    evt.preventDefault();
    open();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    if (!getActiveModal()) return;
    close();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Tab') return;
    var modal = getActiveModal();
    if (!modal) return;
    var dialog = modal.querySelector('.am-klaviyo-in-store-modal__dialog');
    if (!dialog) return;
    var focusable = Array.prototype.slice.call(dialog.querySelectorAll(FOCUSABLE));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  });

  window.klaviyoInStoreForm = {
    __amBound: true,
    open: open,
    close: close,
    setVariant: setVariant,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      init();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
